// General
import React, { useState, useContext, useRef } from "react";
// Contexts
import { DevicesContext } from "../data/devices/DevicesContext";
import { useData } from "../data/general/DataContext";
// Core / Table
import TablePage from "../core/TablePage";
// Modals
import DevicesAddModal from "../modals/devices/DevicesAddModal";
import DevicesUpdateModal from "../modals/devices/DevicesUpdateModal";
// UI / PrimeReact
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
// Icons
import { FaTrash, FaPencilAlt } from "react-icons/fa";


function DevicesPage() {
    const { devicesList, addDevice, updateDevice, deleteDevice } = useContext(DevicesContext);

    const [selectedDevice, setSelectedDevice] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const { windowMode } = useData();

    // Action Menu
    const ActionMenu = ({ rowData }) => {
        const op = useRef(null);
          if (windowMode === "mobile") return null;
        return (
            <>
                <Button
                    label="..."
                    style={{ minWidth: "40px", fontSize: "22px", fontWeight: "bold" }}
                    className="p-button-rounded p-button-text"
                    onClick={(e) => op.current.toggle(e)}
                />
                <OverlayPanel ref={op} dismissable showCloseIcon={false}>
                    <div className="flex flex-col gap-0 p-2 w-32">
                        <Button
                            icon={<FaPencilAlt />}
                            label="Düzenle"
                            className="p-button-text w-full justify-start"
                            onClick={() => {
                                setSelectedDevice(rowData);
                                setShowUpdateModal(true);
                                op.current.hide();
                            }}
                        />
                        <div className="w-full border-t border-gray-300 my-1"></div>
                        <Button
                            icon={<FaTrash />}
                            label="Sil"
                            className="p-button-text w-full justify-start"
                            style={{ color: "red" }}
                            onClick={() => {
                                deleteDevice(rowData.id);
                                op.current.hide();
                            }}
                        />
                    </div>
                </OverlayPanel>
            </>
        );
    };

    // Table Columns
    const columns = [
        { field: "id", header: "ID", hideInFilter: true },
        { field: "brand", header: "Marka" },
        { field: "model", header: "Model" },
        { field: "description", header: "Açıklama" },
         {
                      header: "İşlemler",
                      body: (rowData) =>
                        windowMode === "mobile" ? (
                          // Mobil görünümde direkt butonlar
                          <div className="flex gap-2 mt-2 w-full">
                            <Button
                              icon={<FaPencilAlt />}
                              label="Düzenle"
                              className="flex-1"
                              style={{
                                backgroundColor: "#3b82f6",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                height: "26px",
                                fontSize: "10px",
                                justifyContent: "center",
                                gap: "4px",
                                padding: "0 6px",
                              }}
                              onClick={() => {
                                setSelectedDevice(rowData);
                                setShowUpdateModal(true);
                              }}
                            />
                            <Button
                              icon={<FaTrash />}
                              label="Sil"
                              className="flex-1"
                              style={{
                                backgroundColor: "#ef4444",
                                color: "white",
                                border: "none",
                                borderRadius: "6px",
                                height: "26px",
                                fontSize: "10px",
                                justifyContent: "center",
                                gap: "4px",
                                padding: "0 6px",
                              }}
                              onClick={() => deleteDevice(rowData.id)}
                            />
                          </div>
                        ) : (
                          <ActionMenu rowData={rowData} />
                        ),
                      hideInFilter: true,
                    },
    ];

    // Filtrelenmiş veri
    const filteredDevices = devicesList.filter(
        (d) =>
            !searchTerm || d.brand.toLowerCase().includes(searchTerm.toLowerCase()) || d.model.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const columnFilterOptions = {
        brand: { type: "text" },
        model: { type: "text" },
        description: { type: "text" },
    };

    return (
        <>
            <div className="p-6">
                <TablePage
                    title="Cihaz Listesi"
                    subTitle="Cihaz ekleyebilir, düzenleyebilir veya silebilirsiniz."
                    columns={columns}
                    data={filteredDevices}
                    defaultRows={10}
                    rowsPerPageOptions={[10, 15, 25, 50,100]}
                    showSearch
                    searchValue={searchTerm}
                    onSearchChange={(e) => setSearchTerm(e.target.value)}
                    onAdd={() => setShowAddModal(true)}
                    columnFilterOptions={columnFilterOptions}
                />
            </div>

            <DevicesAddModal
                isOpen={showAddModal}
                onClose={() => setShowAddModal(false)}
            />

            <DevicesUpdateModal
                isOpen={showUpdateModal}
                onClose={() => setShowUpdateModal(false)}
                deviceId={selectedDevice ? selectedDevice.id : null}
            />
        </>
    );
}

export default DevicesPage;
